import { packRevealDepositParameters } from "@keep-network/tbtc-v2.ts";
import SepoliaBitcoinDepositor from "@acre-btc/contracts/deployments/sepolia/BitcoinDepositorV2.json";
import MainnetBitcoinDepositor from "@acre-btc/contracts/deployments/mainnet/BitcoinDepositorV2.json";
import { ZeroAddress, dataSlice, getAddress, isAddress, solidityPacked, zeroPadBytes, } from "ethers";
import { EthereumAddress } from "./address";
import { EthersContractWrapper, } from "./contract";
import { Hex } from "../utils";
/**
 * Ethereum implementation of the BitcoinDepositor.
 */
class EthereumBitcoinDepositor
// @ts-expect-error TODO: Figure out why type generated by typechain does not
// satisfy the constraint `Contract`. Error: `Property '[internal]' is missing
// in type 'BitcoinDepositor' but required in type 'Contract'`.
 extends EthersContractWrapper {
    #cache;
    #tbtcBridge;
    #tbtcVault;
    #tbtcToken;
    constructor(config, network) {
        let artifact;
        switch (network) {
            case "sepolia":
                artifact = SepoliaBitcoinDepositor;
                break;
            case "mainnet":
                artifact = MainnetBitcoinDepositor;
                break;
            default:
                throw new Error("Unsupported network");
        }
        super(config, artifact);
        this.#cache = {
            depositorFeeDivisor: undefined,
        };
    }
    setTbtcContracts({ tbtcBridge, tbtcVault, tbtcToken, }) {
        this.#tbtcBridge = tbtcBridge;
        this.#tbtcVault = tbtcVault;
        this.#tbtcToken = tbtcToken;
    }
    /**
     * @see {BitcoinDepositor#getChainIdentifier}
     */
    getChainIdentifier() {
        return this.getAddress();
    }
    /**
     * @see {BitcoinDepositor#getTbtcVaultChainIdentifier}
     */
    async getTbtcVaultChainIdentifier() {
        const vault = await this.instance.tbtcVault();
        return EthereumAddress.from(vault);
    }
    // eslint-disable-next-line class-methods-use-this
    revealDeposit() {
        throw new Error("Unsupported");
    }
    /**
     * @see {BitcoinDepositor#encodeExtraData}
     * @dev Packs the data to bytes32: 20 bytes of deposit owner address and 2 bytes of
     *      referral, 10 bytes of trailing zeros.
     */
    // eslint-disable-next-line class-methods-use-this
    encodeExtraData(depositOwner, referral) {
        const depositOwnerAddress = `0x${depositOwner.identifierHex}`;
        if (!isAddress(depositOwnerAddress) || depositOwnerAddress === ZeroAddress)
            throw new Error("Invalid deposit owner address");
        const encodedData = solidityPacked(["address", "uint16"], [depositOwnerAddress, referral]);
        return Hex.from(zeroPadBytes(encodedData, 32));
    }
    /**
     * @see {BitcoinDepositor#decodeExtraData}
     * @dev Unpacks the data from bytes32: 20 bytes of deposit owner address and 2
     *      bytes of referral, 10 bytes of trailing zeros.
     */
    // eslint-disable-next-line class-methods-use-this
    decodeExtraData(extraData) {
        const depositOwner = EthereumAddress.from(getAddress(dataSlice(extraData, 0, 20)));
        const referral = Number(dataSlice(extraData, 20, 22));
        return { depositOwner, referral };
    }
    /**
     * @see {BitcoinDepositor#minDepositAmount}
     * @dev The value in tBTC token precision (1e18 precision).
     */
    async minDepositAmount() {
        return this.instance.minDepositAmount();
    }
    /**
     * @see {BitcoinDepositor#calculateDepositFee}
     */
    async calculateDepositFee(amountToDeposit) {
        const depositorFeeDivisor = await this.#depositorFeeDivisor();
        // Compute depositor fee. The fee is calculated based on the initial funding
        // transaction amount, before the tBTC protocol network fees were taken.
        const depositorFee = depositorFeeDivisor > 0n ? amountToDeposit / depositorFeeDivisor : 0n;
        return {
            acre: {
                bitcoinDepositorFee: depositorFee,
            },
        };
    }
    async #depositorFeeDivisor() {
        if (this.#cache.depositorFeeDivisor) {
            return this.#cache.depositorFeeDivisor;
        }
        this.#cache.depositorFeeDivisor = await this.instance.depositorFeeDivisor();
        return this.#cache.depositorFeeDivisor;
    }
    async getTbtcBridgeAddress() {
        return this.instance.bridge();
    }
    async getTbtcVaultAddress() {
        return this.instance.tbtcVault();
    }
    async getTbtcTokenAddress() {
        return this.instance.tbtcToken();
    }
}
export { EthereumBitcoinDepositor, packRevealDepositParameters };
//# sourceMappingURL=bitcoin-depositor.js.map